export default __webpack_public_path__ + "static/twitter-2290e4e93f7a063b6f83b16ceffa6d6c.svg";